import { Form, Input } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { signUp } from "../redux/actions/auth";
import { Link, useNavigate } from "react-router-dom";
import { store } from "../api/index";
import Breadcrumb from "../components/Breadcrumb";

const RegisterScreen = () => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const [form] = Form.useForm();

  const onFinish = (value) => {
    let formData = {
      ...value,
      role: "CUSTOMER",
      store,
    };
    dispatch(signUp(formData, history));
  };

  return (
    <div>
      <Breadcrumb heading={"Register"} />
      <div className="container mx-auto">
        <div className="login_part container mx-auto my-20">
          <div className="md:grid grid-cols-2 gap-20">
            <div className="login_part_text text-center py-20 px-10">
              <h2>Already a member of the Shop?</h2>
              <p>
                There are advances being made in science and technology
                everyday, and a good example of this is the
              </p>
              <div className="flex justify-center items-center">
                <Link to="/account" className="btn_white">
                  Login
                </Link>
              </div>
            </div>
            <div className="login_part_form p-4">
              <h3>Welcome!</h3>
              <Form
                form={form}
                name="basic"
                onFinish={onFinish}
                requiredMark={false}
                layout="vertical"
                autoComplete="off"
              >
                <div className="md:grid grid-cols-2 gap-2">
                  <Form.Item
                    label="Name"
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: "Please input your username!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Phone"
                    name="phone"
                    rules={[
                      { required: true, message: "Please input your Phone!" },
                    ]}
                  >
                    <Input type="number" />
                  </Form.Item>
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Please input your username!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Password"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ]}
                  >
                    <Input.Password />
                  </Form.Item>
                </div>
                <button type="submit" className="info__button ">
                  Register
                </button>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterScreen;
